import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";

const { Text } = Typography;

interface CartQuantityControlProps {
  quantity: number;
  productName: string;
  onDecrease: () => void;
  onIncrease: () => void;
}

export const CartQuantityControl = ({
  onDecrease,
  onIncrease,
  productName,
  quantity,
}: CartQuantityControlProps) => (
  <div className="cart-quantity-control">
    <Button
      aria-label={`Giảm số lượng ${productName}`}
      className="cart-quantity-control__button"
      icon={<MinusOutlined />}
      size="small"
      type="text"
      onClick={onDecrease}
    />
    <Text className="cart-quantity-control__value" strong>
      {quantity}
    </Text>
    <Button
      aria-label={`Tăng số lượng ${productName}`}
      className="cart-quantity-control__button"
      icon={<PlusOutlined />}
      size="small"
      type="text"
      onClick={onIncrease}
    />
  </div>
);
